/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const Slice = createSlice({
  name: 'leadCall',
  initialState: {
    isTabExpended: true,
  },
  reducers: {
    setTabExpend: (state, action) => {
      state.isTabExpended = action.payload;
    },
  },
});

export const { setTabExpend, setTimeLine } = Slice.actions;
export default Slice.reducer;
